<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
		<b-card>
			<b-row>
				<b-col cols="12">
					<app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
				</b-col>
			</b-row>
			<b-row v-if="isUploadSuccess">
				<b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							<b-tab title="Contract Document" active>
								<b-row class="mb-2">
									<b-col>
										<span class="float-right">
											<b-form-select v-model="contractDocumentPageSize" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
										</span>
									</b-col>
								</b-row>
								<b-row>
								<b-col>
								<div class="table-corner">
									<b-table id="my-table" stacked="md" head-variant="light" :no-local-sorting="true" :items="contractDocuments" :fields="fieldsContractDocument" :busy="isDataLoading" :sort-by.sync="sortByContractDocument" :sort-desc.sync="sortDescContractDocument" small responsive>
									<template v-slot:head(actions)>
										<b-button @click="isShowContractDocumentFilter = !isShowContractDocumentFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
									</template>
									<template #top-row v-if="isShowContractDocumentFilter">
										<b-th></b-th>
										<b-th stacked-heading="Surat Masuk">
											<v-select append-to-body label="documentCode" :options="incomingDocuments" :value="filterContractDocument.incomingDocumentId"  :reduce="item => item.id" v-model="filterContractDocument.incomingDocumentId" @search="getIncomingDocuments" :filterable="true"></v-select>
										</b-th>
										<b-th stacked-heading="Surat Keluar">
											<v-select append-to-body label="documentCode" :options="outgoingDocuments" :value="filterContractDocument.outgoingDocumentId"  :reduce="item => item.id" v-model="filterContractDocument.outgoingDocumentId" @search="getOutgoingDocuments" :filterable="true"></v-select>
										</b-th>
										<b-th stacked-heading="Masa Berlaku Kontrak">
											<b-form-datepicker boundary="viewport" placeholder="" id="input-contract-date-from-table" v-model="filterContractDocument.contractDateFrom" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button></b-form-datepicker>
											<b-form-datepicker boundary="viewport" placeholder="" id="input-contract-date-to-table" v-model="filterContractDocument.contractDateTo" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button></b-form-datepicker>
										</b-th>
										<b-th stacked-heading="Status">
											<v-select append-to-body label="name" :options="contractStatuss" :value="filterContractDocument.contractStatusId"  :reduce="item => item.id" v-model="filterContractDocument.contractStatusId" @search="getContractStatuss" :filterable="true"></v-select>
										</b-th>
										<b-th>
										</b-th>
									</template>
									<template v-slot:table-busys>
										<div class="text-center my-2">
									<b-spinner class="align-middle text-primary"></b-spinner>
										<strong class="ml-2">Loading..</strong>
										</div>
									</template>
									<template v-slot:cell(no)="row">
										{{ ((row.index + 1) + ( contractDocumentPageSize * (currentContractDocumentPage - 1))) }}
									</template>
									<template v-slot:cell(incomingDocument)="row">
										{{ row.item.incomingDocument != null ? row.item.incomingDocument.documentCode : "" }}
									</template>
									<template v-slot:cell(outgoingDocument)="row">
										{{ row.item.outgoingDocument != null ? row.item.outgoingDocument.documentCode : "" }}
									</template>
									<template v-slot:cell(contractDate)="row">
										{{ row.item.contractDate | moment("DD-MMM-YYYY")  }}
									</template>
									<template v-slot:cell(contractStatus)="row">
										{{ row.item.contractStatus != null ? row.item.contractStatus.name : "" }}
									</template>
									</b-table>
									</div>
								</b-col>
								<b-col cols="12">
									<b-pagination
									class="float-right btn-paging"
									v-model="currentContractDocumentPage"
									:total-rows="totalContractDocumentRow"
									:per-page="contractDocumentPageSize"
									aria-controls="my-table"
									></b-pagination>
								</b-col>
								</b-row>
							</b-tab>
						</b-tabs>
					</b-card>
				</b-col>
			</b-row>
		</b-card>
		<template #modal-footer="{ ok, cancel }">
			<b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
				Download Log
			</b-button>
			<b-button size="sm" variant="success" class="float-right" @click="ok()">
				{{ okTitle }}
			</b-button>
			<b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
				Cancel
			</b-button>
		</template>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</b-modal>
</template>
<style lang="scss" scoped>
.card {
	border: 1px solid rgba(0, 0, 0, 0.125) !important;
}
:deep .th-message {
	color: red;
}
:deep .modal-footer {
	display: block;
}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate"; 
import { required, minLength } from "vuelidate/lib/validators"; 
import { saveAs } from 'file-saver';

import ContractDocument from '@/models/ContractDocument/ContractDocument';
import ContractDocumentList from '@/models/ContractDocument/ContractDocumentList';
import ContractDocumentFilter from '@/filters/ContractDocument/ContractDocumentFilter';

import IncomingDocument from '@/models/IncomingDocument/IncomingDocument';
import IncomingDocumentFilter from '@/filters/IncomingDocument/IncomingDocumentFilter';
import OutgoingDocument from '@/models/OutgoingDocument/OutgoingDocument';
import OutgoingDocumentFilter from '@/filters/OutgoingDocument/OutgoingDocumentFilter';
import ContractStatus from '@/models/ContractStatus/ContractStatus';
import ContractStatusFilter from '@/filters/ContractStatus/ContractStatusFilter';
import AppInputFileupload from '@/components/AppInputFileupload';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,AppInputDatetimepicker,AppInputDatetimepickerRange,},
	data() {
		return {
			fileupload: null,
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fieldsContractDocument: [
				{"no" : { "class" : "th-number"}}, 
				{"incomingDocument": { "class" : "th-incoming-document", "label" : "Surat Masuk"}, key: 'incomingDocument', sortable: true}, 
				{"outgoingDocument": { "class" : "th-outgoing-document", "label" : "Surat Keluar"}, key: 'outgoingDocument', sortable: true}, 
				{"contractDate": { "class" : "th-contract-date", "label" : "Masa Berlaku Kontrak"}, key: 'contractDate', sortable: true}, 
				{"contractStatus": { "class" : "th-contract-status", "label" : "Status"}, key: 'contractStatus', sortable: true}, 
				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: true},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessage', sortable: true},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			busy:false,
			isDataLoading: false,
			isBusy : false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			contractDocuments : [],
			contractDocumentId : '',
			totalContractDocumentRow : 0,
			isShowContractDocumentFilter: false,
			filterContractDocument : null,
			currentContractDocumentPage : 1,
			contractDocumentPageSize: 10,
			sortByContractDocument: '',
			sortDescContractDocument: '',
			incomingDocuments: [],
			outgoingDocuments: [],
			contractStatuss: [],
			processId: "",
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post(process.env.VUE_APP_API_URL + 'contractdocument/confirmUpload',
					[],
					).then(async function(response){
						if (response != null) {
						if (response.data != null) {
							_this.resetModal();
							_this.datas = Array();
							_this.fileupload = null;
							_this.isUploadSuccess = false;
						}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
				let data = new FormData();
				data.append('file', this.fileupload);
				let _this = this;
				this.$http.post(process.env.VUE_APP_API_URL + 'contractdocument/upload',
					data,
					{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.isBusy = false;
						_this.isUploadSuccess = true;
						_this.getContractDocuments();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getContractDocuments : async function() {
			let filter = {};
			Object.assign(filter, this.filterContractDocument);
			filter.draftFromUpload = "1";
			filter.draftMode = "1";
			this.sortingByContractDocument = Array();
			if (this.sortByContractDocument != null) {
				this.sortingByContractDocument[this.sortByContractDocument] = this.sortDescContractDocument;
			}
			let currentPage = (this.currentContractDocumentPage - 1);
			ContractDocument.getList(this, filter, this.sortingByContractDocument, currentPage , this.contractDocumentPageSize).then(result => {
				this.contractDocuments = result.data;
				this.totalContractDocumentRow = result.dataCount;
			}).catch(error => {});
		},
		getIncomingDocuments : async function(input) {
			let filter = new IncomingDocumentFilter();
			if (input != undefined) {
				filter.documentCode = input;
			}
			IncomingDocument.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.incomingDocuments = result.data
				}
			})
			.catch(error => {});
		},
		getOutgoingDocuments : async function(input) {
			let filter = new OutgoingDocumentFilter();
			if (input != undefined) {
				filter.documentCode = input;
			}
			OutgoingDocument.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.outgoingDocuments = result.data
				}
			})
			.catch(error => {});
		},
		getContractStatuss : async function(input) {
			let filter = new ContractStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ContractStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.contractStatuss = result.data
				}
			})
			.catch(error => {});
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
		downloadLog() {
			let _this = this;
			this.$http.post(process.env.VUE_APP_API_URL + 'contractdocument/downloadlog', [],
			{ headers: { 'Content-Type': 'application/json' }}
			).then(async function(response){
				await saveAs(process.env.VUE_APP_API_URL + 'contractdocument/downloadlog', "ContractDocument.xslx");
				_this.isBusy = false;
			})
			.catch(error => {
				_this.$store.dispatch('addErrorMessageGlobal', error);
				_this.isBusy = false;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		sortByContractDocument : {
			handler: function() {
				this.getContractDocuments();
			}
		},
		sortDescContractDocument: {
			handler: function() {
				this.getContractDocuments();
			}
		},
		currentContractDocumentPage: {
			handler: function() {
				this.getContractDocuments();
			}
		},
		contractDocumentPageSize : {
			handler: function() {
				this.getContractDocuments();
			}
		},
		filterContractDocument: {
			handler: function() {
				this.getContractDocuments();
			},
			deep: true,
		},
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Proses";
				}
				return "Simpan";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterContractDocument = new ContractDocumentFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
